import { gql } from '@/__generated__';

const GET_USER_PREFERENCES_INTERFACE = gql(`#graphql
  query GetUserPreferencesInterface($id: Int) {
    user(id: $id) {
      id
      preferences {
        id
        interface {
          id
          defaultIndexRoute
        }
        defaultInterface: interface(defaultValues: true) {
          defaultIndexRoute
        }
      }
    }
  }
`);

export default GET_USER_PREFERENCES_INTERFACE;
